import { SHOP_SALE_TOWERS, type ShopTowerType } from './unlocks';

/** Meta-shop rows per page — the ShopScene has three fixed row slots (ROW_YS). */
export const SHOP_PER_PAGE = 3;

/**
 * Split the shop's stock into pages. Page 1 (the Cheese Bladesmen, BBQ Bomber
 * and Wise Hambi) is always present. Everything past it holds Chapter-2 towers
 * (General Sniper, Dark Hambi, Ninja Hambi) and is withheld until Chapter 2 is
 * unlocked — i.e. as soon as it becomes playable, not when it is cleared.
 *
 * There is no longer a temporary-page exemption: the four 1-coin introductory
 * towers that needed it moved to the Restaurant's takeout bag, so every tower
 * still on this shelf is a permanent, normally-priced one.
 */
export function shopPages(ch2Unlocked: boolean): ShopTowerType[][] {
  const pages: ShopTowerType[][] = [];
  for (let i = 0; i < SHOP_SALE_TOWERS.length; i += SHOP_PER_PAGE) {
    pages.push(SHOP_SALE_TOWERS.slice(i, i + SHOP_PER_PAGE));
  }
  if (pages.length === 0) pages.push([]);
  return ch2Unlocked ? pages : pages.slice(0, 1);
}
